export default {
  list: {
    title: 'Termo',
    subtitle: 'Lista',
    add: 'Novo jogo',
  },
  table: {
    title: 'Jogos Termo Ativos',
    searchPlaceholder: 'Procurar por algo...',
    letterFilter: 'N.º de letras',
    columns: {
      letters: 'N.º Letras',
      word: 'Palavra',
      publishedDate: 'Data publicação',
    },
  },
  form: {
    title: {
      create: 'Novo termo',
      edit: 'Editar termo',
    },
    name: {
      label: 'Nome:',
      invalid: 'Nome é obrigatório',
    },
    letter: {
      label: 'Qtd. Letra:',
    },
    publishedDate: {
      label: 'Publicação:',
    },
    word: {
      label: 'Palavra:',
      placeholder: 'Escreva a palavra',
      invalid: 'Palavra é obrigatório',
    },
    attempt: {
      label: 'Tentativas:',
      invalid: 'Tentativas é obrigatório',
    },
  },
  delete: {
    title: 'Confirme exclusão de jogo',
    message: 'Tem certeza que deseja excluir este jogo?',
  },
  alert: {
    deleted: 'Jogo deletado com sucesso',
  },
};
